
document.addEventListener("DOMContentLoaded", () => {
  const minAmount = 100; // USD
  const cartFooterSelector = '.cart-footer';
  const checkoutBtnSelector = '.cart-checkout-button';

  // Crea un mensaje de alerta
  const warningMsg = document.createElement('p');
  warningMsg.id = 'checkout-warning';
  warningMsg.style.color = '#d32f2f';
  warningMsg.style.fontSize = '14px';
  warningMsg.style.marginTop = '8px';
  warningMsg.textContent = `Debes tener un mínimo de $${minAmount} para poder finalizar tu compra.`;

  async function checkCartSubtotal() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const subtotal = cart.total_price / 100; // Shopify devuelve centavos

      const footer = document.querySelector(cartFooterSelector);
      const checkoutBtn = document.querySelector(checkoutBtnSelector);

      if (checkoutBtn) {
        if (subtotal < minAmount) {
          checkoutBtn.disabled = true;
          checkoutBtn.style.opacity = '0.5';
          checkoutBtn.style.pointerEvents = 'none';
          checkoutBtn.classList.add('cursor-not-allowed');

          // Agregar mensaje si no existe
        //   if (!document.getElementById('checkout-warning') && footer) {
        //     footer.appendChild(warningMsg);
        //   }
        } else {
          checkoutBtn.disabled = false;
          checkoutBtn.style.opacity = '1';
          checkoutBtn.style.pointerEvents = 'auto';
          checkoutBtn.classList.remove('cursor-not-allowed');
          const msg = document.getElementById('checkout-warning');
          if (msg) msg.remove();
        }
      }
    } catch (error) {
      console.error("Error validando subtotal:", error);
    }
  }

  // Verificar al cargar
  checkCartSubtotal();

  // Re-verificar cuando se actualiza el carrito (Planet Promotions lo hace vía JS)
  const observer = new MutationObserver(() => checkCartSubtotal());
  observer.observe(document.body, { childList: true, subtree: true });

  // También re-verificar periódicamente por seguridad
  setInterval(checkCartSubtotal, 2000);
});